import { action, observable, runInAction, configure } from "mobx";
import { DataProcessingApi } from "apis";
import ApiStore from "./ApiStore";
import BaseStore from "./BaseStore";
import { DATA_PROCESSING_TYPE } from "../core/utils/constants";

configure({ enforceActions: "observed" });
class DataProcessingStore extends BaseStore {
  @observable keepFilterState = false;
  @observable allDataProcessingSettings = [];
  @observable fullDataProcessingSettings = {};
  @observable settingBody = [];
  @observable currentProcess = {};
  @observable currentIndex = 0;
  @observable createdId = -1;
  settingDefault = {
    settingName: "",
    settingBody: "[]",
  };
  processDefault = {
    process_type: 0,
    conditions: [
      {
        condition_type: 0,
        key_condition: "",
        value_condition: "",
      },
    ],
    source_key: "",
    target_key: "",
    before: "",
    after: "",
    comment: "",
  };
  conditionDefault = {
    condition_type: 0,
    key_condition: "",
    value_condition: "",
  };

  constructor(props) {
    super(props);
    this.api = new DataProcessingApi();
    this.fullDataProcessingSettings = JSON.parse(JSON.stringify(this.settingDefault));
  }

  async get(cb = null, isUpdate = false) {
    let response = await ApiStore.call(this.api, this.api.getDataProcessingSetting);
    if (response) {
      runInAction(() => {
        this.allDataProcessingSettings = response;
        cb && cb(isUpdate);
      })
    }
  }

  @action
  setId(id) {
    let target = this.allDataProcessingSettings.find(e => e.id == id);
    if (target === null || target === undefined) {
      this.fullDataProcessingSettings = JSON.parse(JSON.stringify(this.settingDefault));
    } else {
      this.fullDataProcessingSettings = JSON.parse(JSON.stringify(target));
    }
    this.currentIndex = 0;
    this.settingBody = JSON.parse(this.fullDataProcessingSettings.settingBody);
    if (this.settingBody.length <= 0) {
      this.currentProcess = {};
    } else {
      this.currentProcess = JSON.parse(JSON.stringify(this.settingBody[0]));
    }
  }

  addDataProcessingSetting = async (payload, isUpdate = false, cb = null) => {
    let response = await ApiStore.call(this.api, this.api.addDataProcessingSetting, payload);
    if (response) {
      runInAction(() => {
        this.createdId = response.id;
        this.get(this.addDataProcessingSettingCallback, isUpdate);
        cb && cb()
      })
    }
  }

  addDataProcessingSettingCallback = (isUpdate = false) => {
    if (isUpdate) {
      this.setId(this.createdId);
    } else {
      this.setId(null);
    }
  }

  updateDataProcessingSetting = async (payload, cb = null) => {
    let response = await ApiStore.call(this.api, this.api.updateDataProcessingSetting, payload);
    if (response) {
      runInAction(() => {
        this.createdId = response.id;
        this.get(this.updateDataProcessingSettingCallback);
        cb && cb();
      })
    }
  }

  updateDataProcessingSettingCallback = () => {
    this.setId(this.createdId);
  }

  @action
  focusProcessLine = (idx) => {
    this.currentIndex = JSON.parse(JSON.stringify(idx));
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
    this.currentProcess = JSON.parse(JSON.stringify(this.settingBody[this.currentIndex]));
  }

  @action
  insertProcessLine = (idx) => {
    this.settingBody.splice(idx, 0, JSON.parse(JSON.stringify(this.processDefault)));
    if (this.currentIndex >= idx) {
      this.currentIndex = this.currentIndex + 1;
    }
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  insertTailProcessLine = () => {
    this.settingBody.splice(this.settingBody.length, 0, JSON.parse(JSON.stringify(this.processDefault)));
    if (this.currentIndex >= this.settingBody.length) {
      this.currentIndex = 0;
    }
    if (this.settingBody.length <= 1) {
      this.currentProcess = JSON.parse(JSON.stringify(this.settingBody[this.currentIndex]));
    }
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  deleteProcessLine = (idx) => {
    this.settingBody.splice(idx, 1);
    if (this.currentIndex >= idx) {
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : 0;
    }
    if (this.settingBody.length <= 0) {
      this.currentProcess = {};
    } else {
      this.currentProcess = JSON.parse(JSON.stringify(this.settingBody[this.currentIndex]));
    }
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  swapProcessLine = (idx1, idx2) => {
    if (idx1 < 0 || this.settingBody?.length <= idx1 || idx2 < 0 || this.settingBody?.length <= idx2) {
      return;
    }
    [this.settingBody[idx1], this.settingBody[idx2]] = [this.settingBody[idx2], this.settingBody[idx1]];
    if (this.currentIndex == idx1) {
      this.currentIndex = idx2;
    } else if (this.currentIndex == idx2) {
      this.currentIndex = idx1;
    }
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  changeDataProcessingType = (value) => {
    this.currentProcess.process_type = value;
    this.settingBody[this.currentIndex].process_type = value;
    switch (value) {
      case DATA_PROCESSING_TYPE.CONVERSION:
        this.currentProcess.target_key = this.currentProcess.target_key ? this.currentProcess.target_key : "";
        this.currentProcess.before = this.currentProcess.before ? this.currentProcess.before : "";
        this.currentProcess.after = this.currentProcess.after ? this.currentProcess.after : "";
        this.currentProcess.conditions = this.currentProcess.conditions ? this.currentProcess.conditions : [];
        this.currentProcess.comment = this.currentProcess.comment ? this.currentProcess.comment : "";
        break;
      case DATA_PROCESSING_TYPE.MOVE:
        this.currentProcess.source_key = this.currentProcess.source_key ? this.currentProcess.source_key : "";
        this.currentProcess.target_key = this.currentProcess.target_key ? this.currentProcess.target_key : "";
        this.currentProcess.conditions = this.currentProcess.conditions ? this.currentProcess.conditions : [];
        this.currentProcess.comment = this.currentProcess.comment ? this.currentProcess.comment : "";
        break;
      case DATA_PROCESSING_TYPE.COPY:
        this.currentProcess.source_key = this.currentProcess.source_key ? this.currentProcess.source_key : "";
        this.currentProcess.target_key = this.currentProcess.target_key ? this.currentProcess.target_key : "";
        this.currentProcess.conditions = this.currentProcess.conditions ? this.currentProcess.conditions : [];
        this.currentProcess.comment = this.currentProcess.comment ? this.currentProcess.comment : "";
        break;
      case DATA_PROCESSING_TYPE.DELETE:
        this.currentProcess.conditions = this.currentProcess.conditions ? this.currentProcess.conditions : [];
        this.currentProcess.comment = this.currentProcess.comment ? this.currentProcess.comment : "";
        break;
    }
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  changeSettingBodyParam = (key, value) => {
    this.currentProcess[key] = value;
    this.settingBody[this.currentIndex][key] = value;
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
    this.settingBody = JSON.parse(JSON.stringify(this.settingBody));
  }

  @action
  insertCondition = (idx) => {
    this.currentProcess.conditions.splice(idx, 0, this.conditionDefault);
    this.settingBody[this.currentIndex].conditions = JSON.parse(JSON.stringify(this.currentProcess.conditions));
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
  }

  @action
  insertTailCondition = () => {
    this.currentProcess.conditions.splice(this.currentProcess.conditions.length, 0, this.conditionDefault);
    this.settingBody[this.currentIndex].conditions = JSON.parse(JSON.stringify(this.currentProcess.conditions));
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
  }

  @action
  deleteCondition = (idx) => {
    this.currentProcess.conditions.splice(idx, 1);
    this.settingBody[this.currentIndex].conditions = JSON.parse(JSON.stringify(this.currentProcess.conditions));
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
  }

  @action
  changeConditionSelect = (idx, key, value) => {
    this.currentProcess.conditions[idx][key] = value;
    this.settingBody[this.currentIndex].conditions[idx][key] = value;
    this.currentProcess = JSON.parse(JSON.stringify(this.currentProcess));
  }

  @action
  changeConditionInput = (idx, key, value) => {
    this.currentProcess.conditions[idx][key] = value;
    this.settingBody[this.currentIndex].conditions[idx][key] = value;
  }

  formatBody = () => {
    let settingBody = JSON.parse(JSON.stringify(this.settingBody));
    settingBody = settingBody.map(e => {
      switch (e.process_type) {
        case DATA_PROCESSING_TYPE.CONVERSION:
          delete e.source_key;
          break;
        case DATA_PROCESSING_TYPE.MOVE:
          delete e.before;
          delete e.after;
          break;
        case DATA_PROCESSING_TYPE.COPY:
          delete e.before;
          delete e.after;
          break;
        case DATA_PROCESSING_TYPE.DELETE:
          delete e.source_key;
          delete e.target_key;
          delete e.before;
          delete e.after;
          break;
      }
      return e;
    })
    return settingBody;
  }

  addCurrentSetting = async (settingName, isUpdate = false, cb = null) => {
    let settingBody = this.formatBody();
    let payload = {
      setting_name: settingName,
      setting_body: JSON.stringify(settingBody)
    };
    this.addDataProcessingSetting(payload, isUpdate, cb);
  }

  updateCurrentSetting = async (cb = null) => {
    let settingBody = this.formatBody();
    let payload = {
      id: this.fullDataProcessingSettings.id,
      setting_name: this.fullDataProcessingSettings.settingName,
      setting_body: JSON.stringify(settingBody)
    };
    this.updateDataProcessingSetting(payload, cb);
  }

  @action
  currentProcessingType = () => {
    return this.settingBody[this.currentIndex]?.process_type;
  }

  @action
  clean() {
    if (!this.keepFilterState) {
      console.log("DataProcessingSettingStore -> clean -> this.keepFilterState", this.keepFilterState)
      super.clean();
    }
  }

  isBlank = (value) => {
    if (typeof (value) === "string") {
      value = value.trim();
    }
    if (value === null || value === undefined || value === "") {
      return true;
    }
    return false;
  }
}

export default DataProcessingStore;